import * as Yup from 'yup'

import { validatePassword } from '@/components/Inputs/NewPassword/helpers/validatePassword'

export interface RegisterFormData {
  first_name: string
  last_name: string
  cpf: string
  phone: string
  email: string
  password: string
  confirmPassword: string
  is_terms_accepted: boolean
  is_privacy_policy_accepted: boolean
}

export const initialValues: RegisterFormData = {
  first_name: '',
  last_name: '',
  cpf: '',
  phone: '',
  email: '',
  password: '',
  confirmPassword: '',
  is_terms_accepted: false,
  is_privacy_policy_accepted: false,
}

export const validationSchema = Yup.object().shape({
  first_name: Yup.string().required('O campo de nome é obrigatório'),
  last_name: Yup.string().required('O campo de sobrenome é obrigatório'),
  cpf: Yup.string()
    .matches(/^\d{3}\.\d{3}\.\d{3}-\d{2}$/, 'O CPF informado é inválido')
    .required('O campo de CPF é obrigatório'),
  phone: Yup.string()
    .trim()
    .matches(/^\+55 \(\d{2}\) \d{5}-\d{4}$/, 'O telefone informado é inválido')
    .required('O campo de telefone é obrigatório'),
  email: Yup.string().email('O e-mail informado é inválido').required('O campo de e-mail é obrigatório'),
  password: Yup.string().required('O campo de senha é obrigatório').test({
    name: 'password',
    test: validatePassword,
    message: '',
  }),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref('password'), undefined], 'As senhas devem coincidir')
    .required('Confirmação de senha é obrigatória'),
  is_terms_accepted: Yup.boolean().oneOf([true], 'É necessário aceitar os Termos de Uso'),
  is_privacy_policy_accepted: Yup.boolean().oneOf([true], 'É necessário aceitar a Política de Privacidade'),
})
